import { DATA_GRID_FORM_CONTROL_CLASS_NAME } from '../../constants/data-grid';

const dataGridFormControl = ({ theme }) => ({
  '& .MuiInputBase-root': {
    fontSize: theme.typography.small_2.fontSize,
    fontWeight: 500,
  },
});

const MuiFormControl = {
  styleOverrides: {
    root: ({ theme }) => ({
      [`&.${DATA_GRID_FORM_CONTROL_CLASS_NAME}`]: dataGridFormControl({ theme }),
    }),
  },
};

export default MuiFormControl;
